import ProcessConsentPrompt from './ProcessConsentPrompt';
import CookieConsentPrompt from './CookieConsentPrompt';
import ConsentPromptTransitionWrapper from '../../components/ConsentPromptTransitionWrapper';
import useCookieConsentGate from '../hooks/useCookieConsentGate';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ConsentPrompts({
  isSpotlight,
  renderCookieConsentPrompt,
  showingGdprProcess
}) {
  const {
    hasCookieConsentExited,
    handleCookieConsentExited
  } = useCookieConsentGate(renderCookieConsentPrompt);
  const isProcessConsentNeeded = showingGdprProcess && !renderCookieConsentPrompt;
  if (isSpotlight) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ConsentPromptTransitionWrapper, {
        consentPromptEnabled: true,
        isVisible: renderCookieConsentPrompt,
        onExited: handleCookieConsentExited,
        children: /*#__PURE__*/_jsx(CookieConsentPrompt, {})
      }), /*#__PURE__*/_jsx(ConsentPromptTransitionWrapper, {
        consentPromptEnabled: true,
        isVisible: isProcessConsentNeeded && hasCookieConsentExited,
        children: /*#__PURE__*/_jsx(ProcessConsentPrompt, {})
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderCookieConsentPrompt && /*#__PURE__*/_jsx(CookieConsentPrompt, {}), isProcessConsentNeeded && /*#__PURE__*/_jsx(ProcessConsentPrompt, {})]
  });
}
ConsentPrompts.displayName = 'ConsentPrompts';
export default ConsentPrompts;